import Button from "@edaz/edazkit/Button";
import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { IconType } from "@edaz/edazkit/Icon";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { View } from "@frui.ts/views";
import type TransferType from "entities/transferType";
import { Observer, observer } from "mobx-react-lite";
import React from "react";
import { Col, Form, Modal } from "react-bootstrap";
import { formatDateTime } from "utils/localizations";
import BankTransferDetailViewModel from "viewModels/finance/bankExports/bankTransfers/bankTransferDetailViewModel";
import type BankExportDetailViewModel from "viewModels/finance/bankExports/bankExportDetailViewModel";

export interface ExportDetailViewProps {
  vm: BankExportDetailViewModel;
}

const BankExportDetailView = observer((props: ExportDetailViewProps) => {
  const { vm } = props;

  return (
    <>
      <Modal scrollable show={vm.show} onHide={() => vm.handleClose()} centered dialogClassName="modal-90w">
        <Modal.Header closeButton>
          <Modal.Title>{vm.item?.name}</Modal.Title>
          <div className="ml-auto">
            <Button
              size="sm"
              className="rounded"
              disabled={vm.busyWatcher.isBusy}
              onClick={() => vm.download(vm.item)}
              iconLeft={vm.item && vm.busyWatcher.isBusy ? IconType.Spinner : IconType.Download}>
              {vm.translate("downloadFile")}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <LoaderOverlay loading={vm.busyWatcher.isBusy && !vm.item}>
            <h5>{vm.editLabel}</h5>
            <div className="row">
              {vm instanceof BankTransferDetailViewModel && (
                <Form.Group as={Col} md={6} lg={4} xl={3}>
                  <Form.Label>{vm.translateAttribute("refundType")}</Form.Label>
                  <FakeInput
                    target={vm.item}
                    property="refundType"
                    valueFormatter={(paymentType: TransferType) => vm.transferPaymentTypeName(paymentType)}
                  />
                </Form.Group>
              )}
              <Form.Group as={Col} md={6} lg={4} xl={3}>
                <Form.Label>{vm.translateAttribute("createdAt")}</Form.Label>
                <FakeInput
                  target={vm.item}
                  property="createdAt"
                  className="text-nowrap"
                  valueFormatter={value => formatDateTime(value)}
                />
              </Form.Group>
              <Form.Group as={Col} md={6} lg={4} xl={3}>
                <Form.Label>{vm.translateAttribute("createdBy")}</Form.Label>
                <FakeInput target={vm.item} property="createdBy" />
              </Form.Group>
              <Form.Group as={Col} md={6} lg={4} xl={3}>
                <Form.Label>{vm.translateAttribute("paymentsIncludedCount")}</Form.Label>
                <FakeInput target={vm.item} property="paymentsIncludedCount" />
              </Form.Group>
            </div>
            <Observer>{() => <View vm={vm.activeChild} />}</Observer>
          </LoaderOverlay>
        </Modal.Body>
      </Modal>
    </>
  );
});

export default BankExportDetailView;
